import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "setup";
import { UserModel } from "services/api/cplauthapi/CPLAuthAPI";
import { container } from "setup/dependency/inversify.config";
import { IUsersService } from "services/UsersService";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { toast } from "react-toastify";

const initialState = {
  UserProfile: new UserModel(),
  IsEditing: false,
  IsActive: true,
  IsBusy: false,
};

export const fetchUserModelByID = createAsyncThunk("ProfileDetails/FetchUserModelByID", async (userID?: string) => {
  const usersService = container.get<IUsersService>(SERVICE_TYPES.UsersService);
  let userModel: UserModel;

  if (userID === null || userID === undefined) {
    userModel = await usersService.getProfile();
  } else {
    userModel = await usersService.getUserProfile(userID);
  }
  return userModel;
});

export const updateUser = createAsyncThunk("ProfileDetails/UpdateUserModel", async (userModel: UserModel) => {
  const usersService = container.get<IUsersService>(SERVICE_TYPES.UsersService);
  return await usersService.updateUserProfile(userModel);
});

export const updateUserActiveStatus = createAsyncThunk(
  "ProfileDetails/UpdateUserActiveStatus",
  async (userID: string) => {
    const usersService = container.get<IUsersService>(SERVICE_TYPES.UsersService);
    return await usersService.updateUserActiveStatus(userID);
  }
);

export const userProfileSlice = createSlice({
  name: "userProfile",
  initialState,
  reducers: {
    setIsEditing: (state, action) => {
      state.IsEditing = action.payload;
    },
    setIsActive: (state, action) => {
      state.IsActive = action.payload;
    },
    setIsBusy: (state, action) => {
      state.IsBusy = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserModelByID.fulfilled, (state, action) => {
        state.UserProfile = action.payload;
      })
      .addCase(updateUser.pending, (state) => {
        state.IsBusy = true;
      })
      .addCase(updateUser.rejected, (state) => {
        state.IsBusy = false;
      })
      .addCase(updateUser.fulfilled, (state) => {
        toast.success("Profile Updated");
        state.IsEditing = false;
        state.IsBusy = false;
      })
      .addCase(updateUserActiveStatus.fulfilled, (state) => {
        state.IsActive = !state.IsActive;
        toast.success("Profile Status Updated");
      });
  },
});

export const { setIsEditing, setIsActive } = userProfileSlice.actions;

export const selectUserProfile = (state: RootState) => {
  return state.userProfile.UserProfile;
};
export const selectIsEditing = (state: RootState) => {
  return state.userProfile.IsEditing;
};
export const selectIsActive = (state: RootState) => {
  return state.userProfile.IsActive;
};
export const selectIsBusy = (state: RootState) => {
  return state.userProfile.IsBusy;
};

export default userProfileSlice.reducer;
